import styled from 'styled-components';

export const Text = styled.div`
    ${props => props.isChinese
        ? `font-family: 'Microsoft JhengHei', sans-serif;        `
        : `font-family: 'Rambla', 'Arial', sans-serif;`
    }
    ${props => props.fontSize
        ? `font-size: ${props.fontSize};`
        : `font-size: 12px;`
    }
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
`;

export const Button = styled.button`
    flex: 0 0 auto;
    padding: 10px 30px;
    font-size: 1em;
    font-weight: bold;
    margin-left: 10px;
`